function capitalize( str ) {
	let strings = String( str ).split( ' ' );

	return strings
		.map( word => word
			.charAt( 0 )
			.toUpperCase() + word.slice( 1 ) )
		.join( ' ' );
}

export default capitalize;
